import React from "react";
import { Phone } from "lucide-react";
import { motion } from "framer-motion";
import { PHONE_DISPLAY, PHONE_TEL, WHATSAPP_URL } from "../../lib/contact";

const WhatsAppIcon = ({ className = "w-5 h-5" }) => (
  <svg viewBox="0 0 24 24" className={className} fill="currentColor" aria-hidden="true">
    <path d="M19.11 4.92A10 10 0 0 0 4.07 18.2L3 22l3.88-1.03A10 10 0 1 0 19.11 4.92Zm-7.1 15.34a8.27 8.27 0 0 1-4.21-1.15l-.3-.18-2.3.61.62-2.24-.2-.32a8.27 8.27 0 1 1 6.4 3.28Zm4.55-6.2c-.25-.12-1.47-.72-1.7-.8-.23-.09-.39-.13-.56.12-.16.24-.64.8-.78.96-.14.16-.29.18-.54.06-.25-.13-1.05-.39-2-1.23a7.5 7.5 0 0 1-1.38-1.72c-.14-.25-.02-.38.11-.5.11-.11.25-.29.37-.43.13-.14.17-.25.25-.41.08-.16.04-.31-.02-.43-.06-.13-.56-1.34-.76-1.84-.2-.49-.41-.42-.56-.43h-.48a.92.92 0 0 0-.67.31c-.23.25-.88.86-.88 2.1 0 1.24.9 2.44 1.02 2.6.13.17 1.76 2.69 4.27 3.77 1.49.64 2.07.7 2.81.59.45-.07 1.47-.6 1.68-1.19.21-.58.21-1.08.15-1.18-.07-.1-.23-.16-.49-.28Z" />
  </svg>
);

const HALIPAK_GREEN = "#10B981";
const HERO_IMAGE =
  "https://customer-assets.emergentagent.com/job_halipak-solutions/artifacts/0nbnw7ig_image.png";

const Hero = () => {
  return (
    <section
      id="anasayfa"
      data-testid="hero-section"
      className="relative pt-28 sm:pt-36 lg:pt-44 pb-20 lg:pb-28 overflow-hidden bg-[#F8FAFC] grain-overlay"
    >
      {/* Background ornaments */}
      <div className="absolute -top-32 -right-32 w-[520px] h-[520px] rounded-full bg-[#2563EB]/10 blur-3xl pointer-events-none" />
      <div className="absolute -bottom-24 -left-24 w-[420px] h-[420px] rounded-full bg-[#0A192F]/10 blur-3xl pointer-events-none" />

      <div className="container mx-auto px-6 lg:px-8 max-w-7xl relative">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
            className="lg:col-span-7"
          >
            <h1 className="font-heading font-extrabold text-[#0A192F] leading-[1.02] text-5xl sm:text-6xl lg:text-7xl tracking-tight">
              Halı Yıkamada
              <br />
              <span className="relative inline-block">
                <span className="relative z-10">Güvenilir</span>
                <span className="absolute left-0 right-0 bottom-1 h-3 bg-[#2563EB]/25 -z-0" />
              </span>{" "}
              Çözüm Ortağınız.
            </h1>

            <div className="mt-10 flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
              <a
                href={`tel:${PHONE_TEL}`}
                data-testid="hero-phone-cta"
                className="inline-flex items-center justify-center gap-2 rounded-full bg-[#0A192F] text-white px-7 py-4 text-base font-semibold hover:bg-[#112240] active:scale-95 transition-all duration-200 shadow-lg shadow-[#0A192F]/20"
              >
                <Phone className="w-5 h-5" strokeWidth={2.4} />
                Hemen Ara · {PHONE_DISPLAY}
              </a>
              <a
                href={WHATSAPP_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="hero-whatsapp-cta"
                className="inline-flex items-center justify-center gap-2 rounded-full text-white px-7 py-4 text-base font-semibold active:scale-95 transition-all duration-200 shadow-lg"
                style={{ backgroundColor: HALIPAK_GREEN }}
              >
                <WhatsAppIcon className="w-5 h-5" />
                WhatsApp&apos;tan Yaz
              </a>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.9, delay: 0.15, ease: [0.22, 1, 0.36, 1] }}
            className="lg:col-span-5 relative"
          >
            <div className="relative aspect-square rounded-3xl overflow-hidden shadow-xl shadow-[#0A192F]/15 bg-white border border-slate-200">
              <img
                src={HERO_IMAGE}
                alt="HALIPAK Halı Hurcu - 35, 40, 45, 60 cm halı paketleme ruloları"
                className="w-full h-full object-contain p-4 sm:p-6"
                data-testid="hero-product-visual"
                draggable="false"
              />
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
